import Nullstack from 'nullstack';
export default function IconBuildingLighthouse({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-lighthouse",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3l2 3l2 15h-8l2 -15z"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "9",
    x2: "16",
    y2: "9"
  }), "   ", Nullstack.element("path", {
    d: "M3 11l2 -2l-2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M21 11l-2 -2l2 -2"
  }), " ");
}